import Reveal from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What's included with Fourdays?",
    a: "Your subscription grants you unlimited access to book and attend any scheduled event format throughout the month. You only cover your own food, drinks, or activity expenses directly at the venue.",
  },
  {
    q: "Who is Fourdays for?",
    a: "Fourdays is built for travellers wanting to meet new people and connect through curated, real-world group experiences.",
  },
  {
    q: "How do event formats and group matching work?",
    a: "Select your preferred event format (e.g., Drinks/Dinner, Nightlife/Dayclub) on our website. We match you with 4–6 compatible solo travellers, and at T-6 hours (1:00 PM on event day), we reveal the venue location and your group on WhatsApp.",
  },
  {
    q: "Where can I reach customer support?",
    a: "Instagram DM (@fourdaysofficial) is our official touchpoint for all pre-booking queries and general assistance. Our team replies personally with a response time of under 1 hour. After your subscription is active, you can also reach us easily via WhatsApp for any live support or assistance.",
  },
  {
    q: "What if a group doesn't form?",
    a: "If a slot stays under minimum size at T-24 hours, we automatically cancel the group and notify you on WhatsApp with two options:",
    points: [
      "Switch to the next available slot with top-priority matching.",
      "Receive an immediate 100% full refund.",
    ],
  },
  {
    q: "How do I change my slot?",
    a: "If you need to change your slot before group formation, DM us on WhatsApp and we will update your reservation right away.",
  },
  {
    q: "Is the subscription refundable?",
    a: "Subscriptions are non-refundable. However, as mentioned, if we are unable to form a minimum group for your slot at T-24 hours, you are eligible for a full refund.",
  },
  {
    q: "Which languages is Fourdays available in?",
    a: "Only English for now, but we will add further languages as we grow.",
  },
];

export default function FAQ() {
  return (
    <section data-testid="faq-section" className="bg-[#FDFBF7]">
      <div className="max-w-md mx-auto md:max-w-3xl px-5 md:px-8 py-16 md:py-24 border-t border-[#E5E0D8]">
        <Reveal>
          <div className="text-[11px] md:text-xs uppercase tracking-[0.25em] font-semibold text-[#FF5A36]">
            FAQ
          </div>
        </Reveal>
        <Reveal delay={80}>
          <h2 className="mt-3 font-display font-extrabold text-3xl md:text-5xl leading-[1.05] tracking-tight">
            Quick answers.
          </h2>
        </Reveal>

        <Reveal delay={140}>
          <Accordion type="single" collapsible className="mt-8 md:mt-10 w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="border-b border-[#E5E0D8]"
                data-testid={`faq-item-${i + 1}`}
              >
                <AccordionTrigger className="text-left font-display font-bold text-base md:text-lg tracking-tight py-5 hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#5C5C5C] text-[15px] md:text-base leading-relaxed pb-5">
                  {f.a}
                  {f.points && (
                    <ol className="mt-3 space-y-2">
                      {f.points.map((p, j) => (
                        <li key={j} className="flex gap-2.5">
                          <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#FFEDE6] text-[#FF5A36] text-[11px] font-bold">
                            {j + 1}
                          </span>
                          <span>{p}</span>
                        </li>
                      ))}
                    </ol>
                  )}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
